import React from "react"
import { motion } from "framer-motion"

function SectionWrapper({
  visible,
  children,
}: {
  visible: boolean
  children: React.ReactNode
}) {
  return (
    <motion.div
      className="absolute inset-0 flex justify-center"
      style={{ willChange: "opacity, transform" }}
      animate={{
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        zIndex: visible ? 10 : 0,
        scale: visible ? 1 : 0.98,
      }}
      transition={{ duration: 0.45, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  )
}

export default SectionWrapper
